<template>
  <div class="pb-12">
    <Hero />
    <Info />
    <Earning />
  </div>
</template>

<script>
import Hero from '@/components/tokens/Hero.vue'
import Info from '@/components/tokens/Info.vue'
import Earning from '@/components/tokens/Earning.vue'

export default {
  components: {
    Hero,
    Info,
    Earning
  },
  head({ $seo }) {
    return $seo({
      title: 'Tokens',
      description: 'Understand Reward Points system on 100ASA. Earning and usage. How to boost them. User roles.'
    })
  }
}
</script>
